import gMenu from "@/components/g-menu/g-menu.vue"
import gNavbar from "@/components/g-navbar/g-navbar.vue"
import EmpresaController from '@/shared/controllers/empresa/empresaController';
import EVENTS, { CLEAR_EVENTS } from "@/shared/events/events"

const name = 'LayoutLogado'
export default {
    name,
    components: {
        'g-menu': gMenu,
        'g-navbar': gNavbar
    },

    mounted(){
        EmpresaController.getEmpresasAtivas().requisicao
        .then(response => {
        let empresaArray = [];
        empresaArray.push({
            nome: 'TODAS',
            id: null
        })
        this.$store.state.EmpresaArray = empresaArray.concat(response.data.data);
        this.$store.commit('salvando');
        });
    },
    updated(){
        this.limparEventos(EVENTS);
    },
    methods: {
        limparEventos(){
            CLEAR_EVENTS.forEach(x => this.mitt.off(x));
        }
    },
    computed: {
       },
}